import { JSX, useState, useEffect } from 'react'


import { HttpBody } from '@/lib/request'

import * as detective from '@/lib/detective.js'

import * as archive_storage from '@/storage/archive.js'


import * as toast from '@/components/ui/toast.tsx'
// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Drawer from '@/components/ui/drawer.tsx'
// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Field from '@/components/ui/field.tsx'
// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Fieldset from '@/components/ui/fieldset.tsx'





// eslint-disable-next-line @typescript-eslint/naming-convention
export function View (props: { _id: string }): JSX.Element
{
	type TRawDocType = HttpBody<archive_storage.TRawDocumentType>

	let [doc, update_doc] = useState<null | TRawDocType>(null)

	let on_update = (name: string, value: unknown): void =>
	{
		let params = { [name]: value }

		update_doc({ ...doc, ...params } as TRawDocType)

		archive_storage.update(props._id, params)
			.catch(
				(e: unknown) =>
				{
					toast.error(e as Error)

				},

			)


	}

	useEffect(
		() =>
		{
			// eslint-disable-next-line @typescript-eslint/no-floating-promises
			archive_storage.retrieve(props._id).then(update_doc)

		},

		[],

	)

	if (detective.is_empty(doc) )
	{
		return <></>

	}

	return (
		<Fieldset.Root name="员工信息">
			<Field.Text
				label="姓名"
				helper="请填写姓名"
				name="name"
				value={doc.name}
				change={on_update}
			/>

			<Field.Date
				label="出生日期"
				helper="请选择出生日期"
				name="birthday"
				value={doc.birthday}
				change={on_update}
			/>

			<Field.Text
				label="性别"
				helper="请选择性别"
				name="sex"
				value={doc.sex}
				change={on_update}
			/>
			<Field.Text
				label="民族"
				helper="请填写民族"
				name="ethnicity"
				value={doc.ethnicity}
				change={on_update}
			/>

			<Field.Text
				label="身份证号码"
				helper="请填写身份证号码"
				name="identity"
				value={doc.identity}
				change={on_update}
			/>
			<Field.Text
				label="签发机关"
				helper="请填写签发机关"
				name="issue"
				value={doc.issue}
				change={on_update}
			/>

			<Field.RangeDate
				label="有效期"
				helper="请选择有效期"
				name="valid"
				value={doc.valid}
				change={on_update}
			/>

			<Field.Text
				label="证件地址"
				helper="请填写证件地址"
				name="address"
				value={doc.address}
				change={on_update}
			/>

		</Fieldset.Root>

	)

}


export default function (_id: string): void
{
	Drawer.open(
		<View _id={_id} />,

		{ size: 'lg', title: '更新资料' },

	)


}
